<template>
	<div>
		<nk-col-form-group :label="$t('home.widgets.m.widget-name') + ' :'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }" class="widget-title-input">
			<nk-input v-model="settings.title" @update:modelValue="settingsChanged" :options="inputOptions"></nk-input>
		</nk-col-form-group>
	</div>
</template>

<script>
	import _ from 'lodash'

	export default {
		props: {
			options: Object,
			type: String,
		},
		emits: ['settingsChanged'],
		mounted() {
			_.merge(this.settings, this.options)
		},
		data() {
			return {
				settings: {
					title: '',
				},
				inputOptions: {
					type: 'text',
					placeholder: this.$t('home.widgets.m.widget-name'),
				}
			}
		},
		methods: {
			settingsChanged() {
				this.$emit('settingsChanged', this.settings)
			}
		}
	}
</script>

<style></style>